module.exports = __webpack_public_path__ + "img/dnv-logo.32cbcfb7.png";